export var ExecutionDetailsSourceEnum;
(function (ExecutionDetailsSourceEnum) {
    ExecutionDetailsSourceEnum["CREDENTIALS"] = "Credentials";
    ExecutionDetailsSourceEnum["INTERNAL"] = "Internal";
    ExecutionDetailsSourceEnum["PAYLOAD"] = "Payload";
    ExecutionDetailsSourceEnum["WEBHOOK"] = "Webhook";
})(ExecutionDetailsSourceEnum || (ExecutionDetailsSourceEnum = {}));
export var ExecutionDetailsStatusEnum;
(function (ExecutionDetailsStatusEnum) {
    ExecutionDetailsStatusEnum["FAILED"] = "Failed";
    ExecutionDetailsStatusEnum["PENDING"] = "Pending";
    ExecutionDetailsStatusEnum["QUEUED"] = "Queued";
    ExecutionDetailsStatusEnum["READ_CONFIRMATION"] = "ReadConfirmation";
    ExecutionDetailsStatusEnum["SUCCESS"] = "Success";
})(ExecutionDetailsStatusEnum || (ExecutionDetailsStatusEnum = {}));
